(function() {
  'use strict';

  // ── State ──
  var state = { age: '', activities: [], priority: '', step: 0 };
  var TOTAL_STEPS = 3;

  var sheet = document.querySelector('[data-qbs]');
  var overlay = document.querySelector('[data-qbs-overlay]');
  var teaser = document.querySelector('[data-qbs-teaser]');
  if (!sheet) return;

  // ── Product catalog (6 active products, synced 2026-07-09) ──
  var products = [
    { id: 'splash-pad', title: 'Baby Splash Pad – 67" Sprinkler Play Mat', price: '$34.99', priceNum: 34.99, variantId: 45984993444036, img: 'https://cdn.shopify.com/s/files/1/0740/0295/6484/files/702e7b04-c286-41ad-a16d-98740fdab9e5.jpg?v=1783627455', ages: ['6-12m','1-3','3+'], activities: ['water-play','outdoor','beach-pool'], priorities: ['safety','entertainment','easy-cleanup'], reason: 'Safe shallow water play.' },
    { id: 'octopus-sprinkler', title: 'Octopus Water Sprinkler for Little Splashers', price: '$23.99', priceNum: 23.99, variantId: 45985010057412, img: 'https://cdn.shopify.com/s/files/1/0740/0295/6484/files/6318e559-a2f1-43ae-8f04-9ee2cfae6ba5.jpg?v=1783627484', ages: ['6-12m','1-3','3+'], activities: ['water-play','outdoor'], priorities: ['entertainment','easy-cleanup'], reason: 'Gentle sprinkles, giant giggles.' },
    { id: 'bath-squirt-toy', title: 'Octopus Bath Squirt Toy', price: '$19.99', priceNum: 19.99, variantId: 45985008976068, img: 'https://cdn.shopify.com/s/files/1/0740/0295/6484/files/6b52e5b9-6a26-4a37-977f-cecb14050ab5.jpg?v=1783627473', ages: ['0-6m','6-12m','1-3','3+'], activities: ['bath-time'], priorities: ['entertainment','safety','easy-cleanup'], reason: 'Squirt-and-splash bath favorite.' },
    { id: 'bunny-night-light', title: 'Bunny Night Light – Soft Silicone Touch Lamp', price: '$27.99', priceNum: 27.99, variantId: 46371898360004, img: 'https://cdn.shopify.com/s/files/1/0740/0295/6484/files/1b0f237d-a557-4ea2-b497-5fc2445be890.jpg?v=1783582979', ages: ['0-6m','6-12m','1-3','3+'], activities: ['bath-time'], priorities: ['safety','entertainment'], reason: 'Soft glow for calm nights.' },
    { id: 'activity-gym', title: 'Baby Activity Gym – Zoo Sensory Play Mat', price: '$44.99', priceNum: 44.99, variantId: 46371907272900, img: 'https://cdn.shopify.com/s/files/1/0740/0295/6484/files/4351709d-e12a-44b2-898f-4da3090c9eff.jpg?v=1783583108', ages: ['0-6m','6-12m'], activities: ['outdoor'], priorities: ['entertainment','safety'], reason: 'Sensory play from day one.' }
  ];

  // ── Asset URL helper ──
  var assetBase = window.__qbsAssetUrl || '';
  function assetUrl(file) {
    if (/^https?:\/\//.test(file)) return file;
    return assetBase ? assetBase.replace('PLACEHOLDER', file) : '/assets/' + file;
  }

  // ── HTML attribute escaper ──
  function escAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ── Sheet open / close ──
  function openSheet() {
    sheet.classList.add('is-open');
    overlay.classList.add('is-visible');
    if (teaser) teaser.classList.remove('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    // Show teaser after closing
    setTimeout(function() {
      if (teaser) teaser.classList.add('is-visible');
    }, 1000);
  }

  // ── Progress dots ──
  function updateDots() {
    var dots = sheet.querySelectorAll('[data-qbs-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.remove('is-active', 'is-done');
      if (i < state.step) dots[i].classList.add('is-done');
      if (i === state.step) dots[i].classList.add('is-active');
    }
  }

  // ── Screen management ──
  function showStep(n) {
    state.step = n;
    var screens = sheet.querySelectorAll('[data-qbs-screen]');
    for (var i = 0; i < screens.length; i++) {
      screens[i].classList.remove('is-active');
    }
    var target = sheet.querySelector('[data-qbs-screen="' + n + '"]');
    if (target) target.classList.add('is-active');
    updateDots();
    // Scroll sheet to top
    sheet.scrollTop = 0;
  }

  // ── Step 1: Age (single-select, auto-advance) ──
  var ageBtns = sheet.querySelectorAll('[data-qbs-age]');
  for (var a = 0; a < ageBtns.length; a++) {
    ageBtns[a].addEventListener('click', function() {
      for (var j = 0; j < ageBtns.length; j++) ageBtns[j].classList.remove('is-selected');
      this.classList.add('is-selected');
      state.age = this.dataset.qbsAge;
      // Auto-advance after brief visual feedback
      setTimeout(function() { showStep(1); }, 350);
    });
  }

  // ── Step 2: Activity (multi-select, needs next button) ──
  var actBtns = sheet.querySelectorAll('[data-qbs-activity]');
  var actNext = sheet.querySelector('[data-qbs-act-next]');
  for (var ac = 0; ac < actBtns.length; ac++) {
    actBtns[ac].addEventListener('click', function() {
      this.classList.toggle('is-selected');
      state.activities = [];
      var sel = sheet.querySelectorAll('[data-qbs-activity].is-selected');
      for (var s = 0; s < sel.length; s++) state.activities.push(sel[s].dataset.qbsActivity);
      // Enable/disable next
      if (actNext) {
        if (state.activities.length > 0) actNext.classList.add('is-ready');
        else actNext.classList.remove('is-ready');
      }
    });
  }
  if (actNext) {
    actNext.addEventListener('click', function() {
      if (state.activities.length > 0) showStep(2);
    });
  }

  // ── Step 3: Priority (single-select, auto-advance → complete) ──
  var prioBtns = sheet.querySelectorAll('[data-qbs-priority]');
  for (var p = 0; p < prioBtns.length; p++) {
    prioBtns[p].addEventListener('click', function() {
      for (var j = 0; j < prioBtns.length; j++) prioBtns[j].classList.remove('is-selected');
      this.classList.add('is-selected');
      state.priority = this.dataset.qbsPriority;
      setTimeout(function() { completeQuiz(); }, 350);
    });
  }

  // ── Recommendation engine ──
  function computeRecs() {
    var scored = [];
    for (var i = 0; i < products.length; i++) {
      var pr = products[i];
      if (pr.ages.indexOf(state.age) === -1) continue;
      var score = 10;
      for (var a = 0; a < state.activities.length; a++) {
        if (pr.activities.indexOf(state.activities[a]) !== -1) score += 5;
      }
      if (pr.priorities.indexOf(state.priority) !== -1) score += 8;
      scored.push({ product: pr, score: score });
    }
    // Fallback: never return an empty result set
    if (scored.length === 0) {
      for (var f = 0; f < products.length; f++) {
        scored.push({ product: products[f], score: 1 });
      }
    }
    scored.sort(function(a, b) { return b.score - a.score; });
    return scored.slice(0, 4).map(function(s) { return s.product; });
  }

  // ── Complete quiz ──
  function completeQuiz() {
    // Show loading
    showStep('loading');

    // Persist
    sessionStorage.setItem('bb_quiz_age', state.age);
    sessionStorage.setItem('bb_quiz_activities', state.activities.join(','));
    sessionStorage.setItem('bb_quiz_priority', state.priority);

    // Sync cart attributes
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { quiz_age: state.age, quiz_activities: state.activities.join(', '), quiz_priority: state.priority } })
      }).catch(function() {});
    } catch (e) {}

    // Animate loading bar, then show results
    var fill = sheet.querySelector('[data-qbs-loading-fill]');
    if (fill) {
      setTimeout(function() { fill.style.width = '40%'; }, 100);
      setTimeout(function() { fill.style.width = '75%'; }, 600);
      setTimeout(function() { fill.style.width = '100%'; }, 1100);
    }
    setTimeout(function() {
      renderResults(computeRecs());
      showStep('results');
    }, 1500);
  }

  // ── Render results ──
  function renderResults(recs) {
    var grid = sheet.querySelector('[data-qbs-results-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i];
      var card = document.createElement('div');
      card.className = 'qbs__result-card';
      card.innerHTML =
        '<div class="qbs__result-img"><img src="' + assetUrl(r.img) + '" alt="' + escAttr(r.title) + '" loading="eager" decoding="async"></div>' +
        '<div class="qbs__result-body">' +
          '<h4 class="qbs__result-name">' + escAttr(r.title) + '</h4>' +
          '<p class="qbs__result-price">' + r.price + '</p>' +
          '<button class="qbs__result-atc" data-qbs-atc="' + r.variantId + '" data-atc-title="' + escAttr(r.title) + '" data-atc-price="' + r.priceNum + '" type="button">Add to Cart</button>' +
        '</div>';
      grid.appendChild(card);
    }
  }

  // ── Add to cart from results ──
  sheet.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qbs-atc]');
    if (!btn) return;
    var vid = btn.dataset.qbsAtc;
    var text = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        badge.textContent = (parseInt(badge.textContent) || 0) + 1;
        badge.hidden = false;
      }
      setTimeout(function() { btn.textContent = text; btn.disabled = false; }, 1500);
    })
    .catch(function() { btn.textContent = text; btn.disabled = false; });
  });

  // ── Close handlers ──
  var closeBtn = sheet.querySelector('[data-qbs-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);
  if (overlay) overlay.addEventListener('click', closeSheet);

  // ── Teaser reopen ──
  if (teaser) {
    teaser.addEventListener('click', function() {
      openSheet();
    });
  }

  // ── Tap-only entry: show teaser pill on load; sheet opens only via teaser tap ──
  showStep(0);
  if (teaser) teaser.classList.add('is-visible');
})();
